import React, { useState, useContext } from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import { DebugContext } from '../../contexts/DebugContext';
import { IExtraProduct } from '../../models/IChainInfo';
import { EditorContext } from '../EditorCommon/EditorContext';

export function ExtraProduct(props: {
    product: IExtraProduct
}) {
    const ec = useContext(EditorContext);
    const debugContext = useContext(DebugContext);
    const [productCount, setProductCount] = useState(1);

    const defaultMat = props.product.materials.find(m => m.interiorMaterialId === ec.cabinet.interiorMaterialId);
    const defaultMatId = defaultMat?.interiorMaterialId
        ?? props.product.materials[0]?.interiorMaterialId
        ?? null;
    const [materialId, setMaterialId] = useState(defaultMatId);



    function addProduct() {
        ec.cabinetService.addExtraProduct(props.product.id, productCount, materialId);
    }

    return (
        <ListGroup.Item className="extra-product">
            <Card>
                <Card.Img src={props.product.imageUrl} alt="" variant="top" loading="lazy" />
                <Card.Title>
                    {debugContext.value.displayExtendedProductInfo && (props.product.externalId + " - ")}
                    {props.product.name}
                </Card.Title>
                <Card.Body>
                    {props.product.materials.length > 1 && (
                        <select
                            value={materialId}
                            className="form-control"
                            onChange={evt => setMaterialId(parseInt(evt.target.value) ?? null)}
                        >
                            {props.product.materials.map(m => (
                                <option key={m.interiorMaterialId} value={m.interiorMaterialId}>{m.name}</option>
                            ))}
                        </select>
                    )}
                    <div className="input-group">
                        <input type="number"
                            min="1"
                            value={productCount}
                            onChange={evt => setProductCount(evt.target.valueAsNumber)}
                            className="form-control"
                        />
                        <div className="input-group-append">
                            <button className="btn btn-outline-primary"
                                type="button"
                                onClick={addProduct}
                            >
                                {ec.translator("extra product add button", "Tilføj")}
                            </button>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </ListGroup.Item>
    );
}
